// GENERATED CODE - DO NOT EDIT
export const CartItemTypeMap = {
    PRESCRIPTION: 'PRESCRIPTION',
    ESSENTIAL: 'ESSENTIAL',
};
export const PriceTypeMap = {
    WITH_INSURANCE: 'with_insurance',
    WITHOUT_INSURANCE: 'without_insurance',
};
//# sourceMappingURL=cart_item.js.map